
export const addOneMinute = (timeString: string): string => {
  // Create a Date using a fixed base date and the given time
  const date = new Date(`1970-01-01T${convertTo24Hour(timeString)}`);

  // Add 1 minute
  date.setMinutes(date.getMinutes() + 1);

  // Format back to 12-hour format with AM/PM
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

const convertTo24Hour = (time12h: string): string => {
  const [time, modifier] = time12h.split(' ');
  let [hours, minutes] = time.split(':').map(Number);

  if (modifier.toLowerCase() === 'pm' && hours !== 12) {
    hours += 12;
  }
  if (modifier.toLowerCase() === 'am' && hours === 12) {
    hours = 0;
  }

  // Return HH:MM in 24-hour format for ISO string creation
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:00`;
};